import { render } from "./NavBadge.vue?vue&type=template&id=5a24a7df&scoped=true"
const script = {}

import "./NavBadge.vue?vue&type=style&index=0&id=5a24a7df&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a24a7df"]])

export default __exports__